import { customElement } from "lit/decorators.js";
import { CtxContentPreview } from "./ctx-content-preview";

@customElement('ctx-content-preview-light')
export class CtxContentPreviewLight extends CtxContentPreview {
  createRenderRoot() {
    return this;
  }
}